// UI State
export type Theme = 'light' | 'dark' | 'system';

export interface UiState {
  // Sidebar
  sidebarCollapsed: boolean;
  sidebarMobileOpen: boolean;
  
  // Theme
  theme: Theme;
  
  // Notifications
  notificationsPanelOpen: boolean;
  unreadNotificationsCount: number;
  
  // Modals
  activeModal: string | null;
  modalData: Record<string, unknown> | null;
  
  // Loading overlay
  globalLoading: boolean;
  globalLoadingMessage: string | null;
  
  // Breadcrumb
  breadcrumbs: Breadcrumb[];
}

export interface Breadcrumb {
  label: string;
  route?: string;
  icon?: string;
}

export const initialUiState: UiState = {
  sidebarCollapsed: false,
  sidebarMobileOpen: false,
  
  theme: 'system',
  
  notificationsPanelOpen: false,
  unreadNotificationsCount: 0,
  
  activeModal: null,
  modalData: null,
  
  globalLoading: false,
  globalLoadingMessage: null,
  
  breadcrumbs: [],
};
